import { paramsAreDifferent } from '../../helpers';

export function getReferrerParam(param) {
  return document?.referrer && new URL(document.referrer).searchParams.get(param);
}

export function getCurrentParamsObject() {
  if (!window?.location.search) return {};

  const temp = Object.fromEntries(new URLSearchParams(window.location.search));
  let obj = {};

  for (let paramKey in temp) {
    const keys = paramKey.split('[').map((k) => k.replace(']', ''));
    let o = obj;

    while (keys.length - 1) {
      var n = keys.shift();
      if (!(n in o)) o[n] = {};
      o = o[n];
    }

    o[keys[0]] = parseValue(temp[paramKey]);
  }

  return obj;

  function parseValue(val) {
    return val === 'true' ? true : val === 'false' ? false : val;
  }
}

export function updateParams({ newParams, oldParams, vm }) {
  if (window && paramsAreDifferent(newParams, oldParams)) {
    const newUrl = vm.$route(vm.$currentRoute(), newParams).url();
    window.history.replaceState(window.history.state, document.title, newUrl);
  }
}

export function goBack() {
  window.history.back();
}

export function isResearch() {
  return window.location.href.includes('/research/repository/');
}
